import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Card, Table, Tag, Button, Typography, Space } from 'antd';
import { AlertOutlined, PlusOutlined } from '@ant-design/icons';
import { toast } from 'react-toastify';
import { clientService } from '../../../common/services';
import Loader from '../../../components/loader/Loader';
import moment from 'moment';

const { Title } = Typography;

export default function MesSinistres() {
    const navigate = useNavigate();
    const [sinistres, setSinistres] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        loadSinistres();
    }, []);

    const loadSinistres = async () => {
        try {
            const resp = await clientService.getSinistres();
            if (resp.success) {
                setSinistres(resp.data);
            }
        } catch (error) {
            toast.error('Erreur lors du chargement des sinistres');
        } finally {
            setLoading(false);
        }
    };

    const columns = [
        {
            title: 'Contrat',
            dataIndex: ['contrat', 'numeroPolice'],
            key: 'contrat',
        },
        {
            title: 'Type',
            dataIndex: 'typeSinistre',
            key: 'type',
        },
        {
            title: 'Date sinistre',
            dataIndex: 'dateSinistre',
            key: 'date',
            render: (d) => moment(d).format('DD/MM/YYYY'),
        },
        {
            title: 'Date declaration',
            dataIndex: 'dateDeclaration',
            key: 'declaration',
            render: (d) => d ? moment(d).format('DD/MM/YYYY') : '-',
        },
        {
            title: 'Montant estime',
            dataIndex: 'montantEstime',
            key: 'montant',
            render: (v) => v ? `${v.toLocaleString()} FCFA` : '-',
        },
        {
            title: 'Statut',
            dataIndex: 'statut',
            key: 'statut',
            render: (s) => {
                const config = {
                    declare: { color: 'orange', label: 'Declare' },
                    en_cours: { color: 'blue', label: 'En cours' },
                    expertise: { color: 'purple', label: 'Expertise' },
                    resolu: { color: 'green', label: 'Resolu' },
                    rejete: { color: 'red', label: 'Rejete' },
                    clos: { color: 'default', label: 'Clos' },
                };
                const c = config[s] || { color: 'default', label: s };
                return <Tag color={c.color}>{c.label}</Tag>;
            },
        },
    ];

    if (loading) return <Loader />;

    return (
        <div>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16, flexWrap: 'wrap', gap: 12 }}>
                <Title level={3} style={{ margin: 0 }}>
                    <AlertOutlined style={{ marginRight: 8 }} />
                    Mes sinistres
                </Title>
                <Button
                    type="primary"
                    icon={<PlusOutlined />}
                    onClick={() => navigate('/espace-client/sinistres/declarer')}
                >
                    Declarer un sinistre
                </Button>
            </div>

            <Card>
                <Table
                    dataSource={sinistres}
                    columns={columns}
                    rowKey="_id"
                    pagination={{ pageSize: 10 }}
                    scroll={{ x: 700 }}
                    locale={{ emptyText: 'Aucun sinistre declare' }}
                />
            </Card>
        </div>
    );
}
